import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { getAuthConfig } from "./lib/authConfig";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import NewIdea from "./pages/NewIdea";
import IdeaDetail from "./pages/IdeaDetail";
import AuthCallback from "./pages/AuthCallback";
import SharedDiagnosis from "./pages/SharedDiagnosis";
import AuthForm from "./pages/AuthForm";
import Profile from "./pages/Profile";
import ContactFeedback from "./pages/ContactFeedback";
import { AnalyticsTracker } from "./analytics";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="overline">loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    getAuthConfig().then((c) => setProvider(c.provider));
  }, []);

  // Handle OAuth callback — Google uses ?code=, Emergent uses #session_id=
  if (location.search?.includes("code=") || location.hash?.includes("session_id=")) return <AuthCallback />;

  if (!provider) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="overline">loading…</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Landing authProvider={provider} />} />
      <Route path="/contact" element={<ContactFeedback />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/share/:slug" element={<SharedDiagnosis />} />
      <Route path="/startup-idea/:slug" element={<SharedDiagnosis />} />
      {provider === "jwt" && (
        <>
          <Route path="/login" element={<AuthForm mode="login" />} />
          <Route path="/register" element={<AuthForm mode="register" />} />
        </>
      )}
      <Route
        path="/dashboard"
        element={
          <Protected>
            <Dashboard />
          </Protected>
        }
      />
      <Route
        path="/new"
        element={
          <Protected>
            <NewIdea />
          </Protected>
        }
      />
      <Route
        path="/ideas/:idea_id"
        element={
          <Protected>
            <IdeaDetail />
          </Protected>
        }
      />
      <Route
        path="/profile"
        element={
          <Protected>
            <Profile />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </BrowserRouter>
  );
}
